import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  deleteAdministrator,
  fetchAdministratorList,
} from "../actions/administrator";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { statusRender } from "../utils/cellRenderTable";
import { createDateColumn } from "../utils/agGridDateColumn";
import { ADMINISTRATOR_TYPE_LABELS } from "../utils/auth";

const AdministratorList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { administratorList } = useSelector(
    (state) => state.administratorReducer
  );

  //breadcrumb
  const translateModule = "administrator";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchAdministratorList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/administrator-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(deleteAdministrator(pageId));
  };

  const columnDefs = [
    {
      headerName: "Ime",
      field: "name",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Prezime",
      field: "surname",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Email adresa",
      field: "email",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: "Tip",
      field: "type",
      filter: "agSetColumnFilter",
      valueGetter: (params) =>
        ADMINISTRATOR_TYPE_LABELS[params.data?.type] || params.data?.type || "",
    },
    createDateColumn("Datum kreiranja", "createdAt"),
    {
      headerName: "Aktivan",
      field: "active",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      maxWidth: 180,
      valueGetter: (params) => {
        if (params.data?.active === true) return "Aktivan";
        if (params.data?.active === false) return "Neaktivan";
        return "";
      },
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={administratorList}
        columnDefs={columnDefs}
        buttonLink={`/administrator-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="administrator-list"
      />
    </Fragment>
  );
};

export default AdministratorList;
